import React, { forwardRef, Suspense, useState } from 'react';
import { Card, Skeleton } from 'antd';
import "./DashboardWidget.css"
import useWindowDimensions from '../../hooks/useWindowDimensions';

const loadWidget = ( widget) => {
  return () => import(`@/${widget}`);
};



export const DashboardWidget = forwardRef((props, ref) => {
  const { component } = props;
  const size = useWindowDimensions();
  const [WidgetComponent] = useState(React.lazy(loadWidget(component)));
  //console.log("Dashboard widget props:", props)

  return (
    <div ref={ref} {...props} >
      <Suspense fallback={<Skeleton active={true} />}>
        <Card className={`dashboard-widget ${size.width < 560 && 'not-draggable' || ''}`}>
            <WidgetComponent {...props} />
            
        </Card>
    
        {props.children}
        {props.isPrinting && <div className="pagebreak"></div>}
      </Suspense>
    </div>
  );
});